import { render, staticRenderFns } from "./MultipleFormComponent.vue?vue&type=template&id=7ef22083&scoped=true"
import script from "./MultipleFormComponent.vue?vue&type=script&lang=js"
export * from "./MultipleFormComponent.vue?vue&type=script&lang=js"
import style0 from "./MultipleFormComponent.vue?vue&type=style&index=0&id=7ef22083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef22083",
  null
  
)

export default component.exports